import React, { useState, useEffect } from "react";
import PageTitle from "../../Module/pageTitle";
import InputField from "../../Component/inputField";
import { useDispatch } from "react-redux";
import { containsNumber, containsNumberwithSign, length_Eight, length_Two } from "../../Utils/validators";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import SubmitButton from "../../Component/SubmitButton";
import Dropdown from "../../Component/dropdown";
import LabelField from "../../Component/labelField";
import { getPackageOfferSetting, updatePackageOfferSetting } from "../../Action/actionFile";

function GlobalSpecialDiscount() {
  const dispatch = useDispatch();
  const [discPer, setDiscPer] = useState("");
  const [pricePerdisc, setPricePerdisc] = useState("");
  const [discId, setdiscId] = useState(0);
  const [type, setType] = useState("");
  const typeList = [{
    _id: 1,
    name: "Course"
  },
  {
    _id: 3,
    name: "Book"
  },
  ]
  const handleSubmit = (event) => {
    event.preventDefault();
    const postData = {
      discPer: discPer,
      pricePerDisc: pricePerdisc
    };
    dispatch(
      updatePackageOfferSetting(postData, discId, () => {

      })
    );
  };
  const onChangeDiscount = (value) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        dispatch(showErrorSnackbar("Only numbers are allowed"));
        return;
      }
    }
    setDiscPer(value);
  };


  const onChangePrice = (value) => {
  if (value !== "") {
    if (!containsNumberwithSign(value)) {
      dispatch(showErrorSnackbar("Only numbers with up to 2 decimals are allowed"));
      return;
    }
  }
  setPricePerdisc(value);
};

  const validations = () => {
    return !discPer || discPer.length === 0 || !type || type.length === 0 || !pricePerdisc || pricePerdisc.length === 0;
  };
  const onChangeType = (value) => {
    setType(value);
    if (value) {
      const data = {
        type: value?._id,
      };
      dispatch(
        getPackageOfferSetting(
          data,
          (res) => {
            if (res) {
              if (res?.data && res?.data?.length > 0) {
                setdiscId(res?.data[0]?._id);
                setDiscPer(res?.data[0]?.discPer); // Set discount percentage from API response
                setPricePerdisc(res?.data[0]?.pricePerDisc); // Set discount percentage from API response
              }
              else {
                setdiscId("");
                setDiscPer("");
                setPricePerdisc("");
              }
            }
          },
          () => { }
        )
      );
    }
  };

  return (
    <div className="contentBox">
      <PageTitle name={"Global Special Discount"} />

      <div className="formDiv">
        <form className="formWidth" onSubmit={handleSubmit}>
          <div className="col-md-12 mt-3">
            <div className="col-md-12 align-items-center d-flex">
              <LabelField labelName={"Type"} isRequired={true} />
              <div className="w-100">
                <Dropdown
                  labelName="Select Type"
                  setInputText={(value) => onChangeType(value)}
                  options={typeList}
                  value={type}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex mb-2 align-items-center">
                <InputField
                  labelName={"Percentage"}
                  setInputText={onChangeDiscount}
                  value={discPer}
                  maxlength={length_Two}
                  Isrequired={true}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex mb-2 align-items-center">
                <InputField
                  labelName={"Price Per Discount"}
                  setInputText={onChangePrice}
                  value={pricePerdisc}
                  maxlength={length_Eight}
                  Isrequired={true}
                />
              </div>
            </div>
          </div>

          <div className="col-auto d-flex justify-content-center mt-4">
            <SubmitButton name="Update" validations={validations()} />
          </div>
        </form>
      </div>
    </div>
  );
}

export default GlobalSpecialDiscount;
